module.exports = __webpack_public_path__ + "img/logo_cnsr.f98fe9a6.png";